import { render, staticRenderFns } from "./OrganisationLayout.vue?vue&type=template&id=b6bef584&"
import script from "./OrganisationLayout.vue?vue&type=script&lang=js&"
export * from "./OrganisationLayout.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports